import type {PropsWithChildren} from 'react';
import styles from './right.module.css';

type Props = PropsWithChildren;

export function PressReleaseHeaderRight({children}: Props) {
  return <div className={styles.right}>{children}</div>;
}
